import PropTypes from "prop-types";
import React from "react";

import Button from "../../../UI/Button";
import images from "../../../../utils/images";

export const ChatMenu = (props) => {
  const { archiveConversation, hideMenu } = props;

  return (
    <div className="chat-modal">
      <div className="chat-modal-card">
        <div className="chat-modal-body">
          <img
            alt="close"
            className="GuidedVideoCall__close-btn"
            onClick={hideMenu}
            role="button"
            src={images("./icons/cross.svg")}
          />
          <p className="mt-2 tw:font-bold">Archive Conversation?</p>
          <Button className="Btn Btn--err" onClick={archiveConversation} type="button">
            Archive
          </Button>
        </div>
      </div>
    </div>
  );
};

ChatMenu.propTypes = {
  archiveConversation: PropTypes.func.isRequired,
  hideMenu: PropTypes.func.isRequired,
};
